class transition {
	constructor() {}
	show() {
		return new Promise( (resolve, reject) => {
			TweenMax.to(this.loading, 1, {
				opacity: 0,
				onComplete: () => {
					this.reset();
					resolve();
				}
			})
			
		});
	}
	hide() {
		return new Promise( (resolve, reject) => {
			TweenMax.to(this.loading, 0, {
				opacity: 1,
				onComplete: () => {
					this.html.classList.add('isLoading');
					let t = setTimeout(() => {
						clearTimeout(t);
						resolve();
					}, 500)
				}
			})
		});
	}
	reset() {
		this.html.classList.remove('isLoading');
	}
	init() {
		this.html = document.documentElement;
		this.loading = document.querySelector('.cmn-loading');
		return new Promise( (resolve, reject) => {
			resolve();
		});
	}
}

export default transition;


// WEBPACK FOOTER //
// ./src/assets/js/transition.js